/**
 * Error handling utilities for API responses
 */

/**
 * Extract error message from various API error formats
 * Handles:
 * - string: Returns as-is
 * - Pydantic v2 array: [{type, loc, msg, input, url}] -> extracts msg
 * - Object with detail/msg/message: Returns the message field
 * 
 * @param {any} error - The error detail from API response
 * @param {string} fallback - Fallback message if extraction fails
 * @returns {string} Human-readable error message
 */
export const extractErrorMessage = (error, fallback = 'An error occurred') => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  if (Array.isArray(error)) {
    // Pydantic v2 validation errors - extract msg from each
    return error.map(e => e.msg || e.message || JSON.stringify(e)).join(', ');
  }
  if (typeof error === 'object') {
    return error.msg || error.message || error.detail || JSON.stringify(error);
  }
  return fallback;
};

/**
 * Get error message from axios error response
 * 
 * @param {Error} err - Axios error object
 * @param {string} fallback - Fallback message
 * @returns {string} Human-readable error message
 */
export const getApiErrorMessage = (err, fallback = 'An error occurred') => {
  return extractErrorMessage(err?.response?.data?.detail, fallback);
};

const errorUtils = { extractErrorMessage, getApiErrorMessage };
export default errorUtils;
